import { useContext } from "react";
import { MaterialOrderContext } from "../context/MaterialOrderContext";
import { MaterialOrderReportType } from "../types/MaterialOrderReportType";
import PrintButton from "./PrintButton";

export default function PrintInvoiceButton() {

	const { order } = useContext(MaterialOrderContext);

	return (
		<>
			<PrintButton elementAttr={{ 'data-testid': 'btn-print-invoice' }}
				buttonCaption="Print Invoice"
				reportType={MaterialOrderReportType.Invoice}
				visible={order.details.purchaseOrders.filter(x => !!x.validatedShipDate || !!x.validatedDeliveryDate).length > 0}
			/>
		</>
	)
}
